import { ResponsiveSet } from 'core/ribbons/primitives';
import { ColumnCount } from 'domain/constants/layout';

const responsiveColumns = (
  defaultColumns: ResponsiveSet<ColumnCount>,
  desiredColumns = [null, null, null] as unknown as ResponsiveSet<ColumnCount>,
) => {
  const columns = desiredColumns.map((value, index) => {
    const defaultedDesiredValue = value ?? null;
    const prunedValue = defaultedDesiredValue === null ? defaultColumns[index] : defaultedDesiredValue;
    return prunedValue;
  });
  return columns;
};

export const bootstrapResponsiveColumns = (
  defaultColumns: ResponsiveSet<ColumnCount>,
  desiredColumns: ResponsiveSet<ColumnCount>,
) => {
  const columns = responsiveColumns(defaultColumns, desiredColumns);
  const dividedColumns = columns.map((value) => (typeof value === 'number' ? 12 / value : value));
  return dividedColumns as ResponsiveSet<ColumnCount>;
};

export default responsiveColumns;
